.af{min-width:0px;}